import React from 'react';
import { Row, Col } from 'antd'
import orangeC from '../../assets/orange-c.png';

const intl = {
  block1: {
    headline: {
      'en': 'COMMUNICATION',
      'dk': 'KOMMUNIKATION'
    },
    body: {
      'en': <div>
        <span style={{ color: '#1abc9c' }}>TA</span> We work with Transactional Analysis as a way to improve self-awareness about ways to communicate, emotional reactions, early patterns and how we impact each other and what the unintended consequences often are.
        <br /><br />
        <span style={{ color: '#1abc9c' }}>Feedback</span> We insist that any organization that wishes to implement continuous improvement need a healthy and consistent feedback culture. It has to be constructive and progressive and above all build instead of tearing down.
        <br /><br />
        <span style={{ color: '#1abc9c' }}>Dialogue</span> We work with dialogue as a method to improve inter-relational understanding and communication. The methodology builds on Schein and relative simple in construct it creates tremendous value.
        <br /><br />
        <span style={{ color: '#1abc9c' }}>Honest conversation</span> A workshop designed to address the issue of improving performance. It requires attention to intent and maintaining the right amount of pressure in the feedback to ignite the development needed.
      </div>,
      'dk': <div>
        <span style={{ color: '#1abc9c' }}>TA</span> Vi anvender Transaktions Analyse som metode til at skabe bevidsthed omkring hvorledes vi kommunikerer, emotionelle reaktioner, tidlige mønstre og hvordan vi påvirker hinanden og hvad de ofte utilsigtede konsekvenser kan afstedkomme.
        <br /><br />
        <span style={{ color: '#1abc9c' }}>Feedback</span> Såfremt organisationer insisterer på kontinuerlige forbedringer, så kræver det en sund og vedholdende feedback kultur. Det skal være konstruktivt, progressivt og fremfor alt opbyggende mere end nedbrydende i sin form.
        <br /><br />
        <span style={{ color: '#1abc9c' }}>Dialog</span> Vi arbejder med dialog som metode til at forstå og forbedre relationer mellem mennesker. Metoden bygger på Schein og trods sin enkle opbygning skaber den enestående værdi når den anvendes.
        <br /><br />
        <span style={{ color: '#1abc9c' }}>Ærlig konversation</span> En workshop designet til at øge ydeevne og præstations kvalitet. Det kræver focus på hensigt og fastholdelse af et insisterende feedback med henblik på at iværksætte den nødvendige udvikling.
      </div>,
    }
  },
  block2: {
    headline: {
      'en': 'CHANGE',
      'dk': 'FORANDRING'
    },
    body: {
      'en': <div>
        <span style={{ color: '#1abc9c' }}>Relational Coordination</span> focuses on the importance of collaboration, knowledge sharing, mutual respect and communication both within and between groups. In combination, these factors influence the quality of groups working together and solving problems. We guide and facilitate the practical application of this method and train the organization to work informed by this methodology.
        <br /><br />
        <span style={{ color: '#1abc9c' }}>Team building</span> covers a broad range and although it can contain an element of humorous task solving this in itself does not create a team. We work with building trust i.e. by facilitated storytelling, psychodynamic coaching, and metallization and group supervision.
        <br /><br />
        <span style={{ color: '#1abc9c' }}>Accelerated change </span> Based on iLeads own research we instigate and facilitate change processes mixing a practical approach with psychodynamic understanding of the dynamics in play when people need to change what they do. By this approach change processes can actually be accelerated with a improvement in results.
        <br /><br />
      </div>,
      'dk': <div>
        <span style={{ color: '#1abc9c' }}>Relationel koordinering</span> fokuserer på vigtigheden af vidensdeling, gensidig respekt og kommunikation –både i- og mellem grupper. Tilsammen påvirker disse faktorer kvaliteten af samarbejdet og evnen til at løse udfordringer sammen. Vi guider og faciliterer den praktiske anvendelse af denne metode og opøver organisationen i at arbejde med metoden.
        <br /><br />
        <span style={{ color: '#1abc9c' }}>Team building </span> dækker over en bred vifte af aktiviteter. Skønt disse kan indeholde et element af humoristisk problemløsning, skaber dette i sig selv ikke et velfungerende team. Vi arbejder målrettet med at opbygge tillid gennem fx faciliteret historie fortælling, psykodynamisk coaching, mentalisering samt gruppe supervision.
        <br /><br />
        <span style={{ color: '#1abc9c' }}>Accelereret forandring </span> Baseret på iLEAD A/S egen forskning initierer og faciliterer vi forandringsprocesser, der bygger på en praktisk- og målrettet tilgang. Kombineret med en psykodynamisk forståelse af de dynamikker, der opstår når forandring resulterer i et behov for menneskelig udvikling. Denne specifikke metode betyder at forandringstiltag kan accelereres med bedre resultater til følge
        <br /><br />
      </div>,
    }
  },
  block3: {
    headline: {
      'en': 'CULTURE',
      'dk': 'KULTUR'
    },
    body: {
      'en': <div>
        <span style={{ color: '#1abc9c' }}>Culture analysis</span> We use psychodynamic systems theory to analyze the system as a whole and look closely as group dynamics and leadership relations.
        <br /><br />
        <span style={{ color: '#1abc9c' }}>Cultural mapping</span> We map existing cultures up against desired ones using Cameron & Quinns Competing Values Framework on a tangible practical level and Scheins cultural understanding on a high level understanding of cultural dimension.
        <br /><br />
        <span style={{ color: '#1abc9c' }}>Culture development</span> We work with organizational development in conjunction with the analysis and mapping. Intent and actions has to be aligned – not just in words but even more so in behavior.
        <br /><br />
        <span style={{ color: '#1abc9c' }}>Cultural fit</span> All Mergers & Acquisitions make sense in the planning and decision making process. And while the promise of synergies and financial gains seems unavoidable for some reason they don't materialize. The reason is because the cultural fit was wrong. Let us help you get it right.
      </div>,
      'dk': <div>
        <span style={{ color: '#1abc9c' }}>Kulturanalyse </span> Vi anvender psykodynamisk system teori til at analysere systemer i deres helhed og ser nøje på gruppe dynamikker og leder relationer.
        <br /><br />
        <span style={{ color: '#1abc9c' }}>Kulturkortlægning </span> Vi kortlægger den eksisterende kultur og holder den op i mod ønsket adfærd. Vi anvender Cameron & Quinns Paradokser i Værdiledelse som en håndgribelig og praksis orienteret tilgang samt Scheins forståelse af kultur på generisk niveau.
        <br /><br />
        <span style={{ color: '#1abc9c' }}>Kulturudvikling </span> Vi arbejder med organisations udvikling sideløbende og som resultat  af kortlægning og analyse. Hensigt og handling skal tilpasses så de understøtter hinanden - ikke kun i ord men i adfærd.
        <br /><br />
        <span style={{ color: '#1abc9c' }}>Kulturelt match </span> Alle fusioner og overtagelser giver mening i planlægnings- og beslutnings-processen. Mens løftet om synergier og økonomiske gevinster synes uundgåelige, udebliver de ofte af en eller anden grund. Årsagen er oftest, at det kulturelle match er forkert. Lad os hjælpe jer, med at finde det rigtige.
      </div>,
    }
  },
}

function ThreeColumns(props) {
  return (
    <Row style={{ backgroundColor: '#fff', color: '#000', paddingTop: '50px', paddingBottom: '100px' }}>
      <Col sm={24} md={{ span: 20, offset: 2 }}>
        <Row gutter={24}>
          <Col sm={24} md={{ span: 8 }} style={{ position: 'relative', height: '100%' }}>
            <div
              style={{
                height: '100%',
                textAlign: 'left',
              }}
            >
              <div className="blog_block_content">
                <h2
                  style={{
                    fontSize: '20px',
                    letterSpacing: '1px',
                    lineHeight: '25px',
                    textTransform: 'uppercase',
                    color: '#1abc9c',
                    position: 'relative',
                    marginBottom: '50px',
                  }}
                >
                  <img alt='images' src={orangeC} className="services_orange_c" style={{ left: '-30px' }} />
                  <span style={{ position: 'relative', zIndex: 1 }}>
                    {intl.block1.headline[props.language]}
                  </span>
                </h2>
                <p
                  style={{
                    color: '#8c8c8c',
                    marginBottom: '25px',
                    fontSize: '14px',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intl.block1.body[props.language]}
                </p>
              </div>
            </div>
          </Col>
          <Col sm={24} md={{ span: 8 }} style={{ position: 'relative', height: '100%' }}>
            <div
              style={{
                height: '100%',
                textAlign: 'left',
              }}
            >
              <div className="blog_block_content">
                <h2
                  style={{
                    fontSize: '20px',
                    letterSpacing: '1px',
                    lineHeight: '25px',
                    textTransform: 'uppercase',
                    color: '#1abc9c',
                    marginBottom: '50px',
                  }}
                >
                  <img alt='images' src={orangeC} className="services_orange_c" />
                  <span style={{ position: 'relative', zIndex: 1 }}>
                    {intl.block2.headline[props.language]}
                  </span>
                </h2>
                <p
                  style={{
                    color: '#8c8c8c',
                    marginBottom: '25px',
                    fontSize: '14px',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intl.block2.body[props.language]}
                </p>
              </div>
            </div>
          </Col>
          <Col sm={24} md={{ span: 8 }} style={{ position: 'relative', height: '100%' }}>
            <div
              style={{
                height: '100%',
                textAlign: 'left',
              }}
            >
              <div className="blog_block_content">
                <h2
                  style={{
                    fontSize: '20px',
                    letterSpacing: '1px',
                    lineHeight: '25px',
                    textTransform: 'uppercase',
                    color: '#1abc9c',
                    marginBottom: '50px',
                  }}
                >
                  <img alt='images' src={orangeC} className="services_orange_c" />
                  <span style={{ position: 'relative', zIndex: 1 }}>
                    {intl.block3.headline[props.language]}
                  </span>
                </h2>
                <p
                  style={{
                    color: '#8c8c8c',
                    marginBottom: '25px',
                    fontSize: '14px',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {intl.block3.body[props.language]}
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default ThreeColumns;



// WEBPACK FOOTER //
// ./src/pages/Services/ThreeColumns.js